import { Box, Button, Grid2, InputBase, Paper, Typography, useMediaQuery } from "@mui/material";
import Styles from "./EquityMob.module.css";
import { useState } from "react";
import validator from "validator";
import { backendHosts } from "../../../../ui-utils/apiConfig"
import leftPic from "../../../../ui-utils/latestPics/equityleft.svg"
import en from "../../../../i18n/English/Trade Invest/home.json";
import hi from "../../../../i18n/Hindi/Trade Invest/home.json";
import kn from "../../../../i18n/Kannada/Trade Invest/home.json";
import ma from "../../../../i18n/Marathi/Trade Invest/home.json";
import gu from "../../../../i18n/Gujarati/Trade Invest/home.json";
import { useLanguage } from "../../../../Context/LangContext";
export default function EquityMob() {
    const [mobileNo, setMobileNo] = useState("");
    const clientErr = {};
    const [mobClientErr, setMobileClientErr] = useState({});

    const isSmallScreen = useMediaQuery("(max-width:600px)");
  const { language } = useLanguage();
  const translations = { en, hi, kn ,ma,gu};
  const t = translations[language];
    const handleMobilenoEnter = () => {
        const formData = { mobileNo };
        console.log(formData);
        const runValidation = () => {
            if (mobileNo.trim().length == 0) {
                clientErr.mobileNo = "Please enter your mobile number.";
                return;
            }
            if (!validator.isMobilePhone(mobileNo, "en-IN")) {
                clientErr.mobileNo = "Please enter a valid mobile number.";
                return;
            }
        };
        runValidation();
        if (Object.keys(clientErr).length == 0) {

            const fullUrl = `${backendHosts.REG}/?mobilenofromhome=${mobileNo}&t=${Date.now()}`;
            window.location.href = fullUrl;
            setMobileClientErr({});

        } else {
            setMobileClientErr(clientErr);
        }
    };

    const handleMobileNoChange = (e) => {
        const inputValue = e.target.value;
        const numericValue = inputValue.replace(/\D/g, "");
        const limitedValue = numericValue.slice(0, 10);

        setMobileNo(limitedValue);
    };
    return (
        <Box className={Styles.HomeSectionBox}>



            <Grid2>
                <img src={leftPic} alt="equity" className={Styles.leftPic} />
            </Grid2>

            <Grid2 className={Styles.fieldCard}>
                <div className={Styles.headingContainer}>
                    <div className={Styles.gradientBackground}></div>
                    <Typography className={Styles.heading} style={{ fontWeight: 600 }}>
                        {t.heading}
                    </Typography>
                </div>
                <Typography className={Styles.subtitle}>{t.subtitle}</Typography>
                <Paper component="form" className={Styles.mobilefield}>
                    <Typography className={Styles.preMobile}>91</Typography>

                    <InputBase
                        className={Styles.inputbase}
                        placeholder={t.mobilePlaceholder}
                        onChange={handleMobileNoChange}
                        value={mobileNo}
                    />
                </Paper>

                {mobClientErr.mobileNo && (
                    <Typography className={Styles.errMsgg}>
                        {mobClientErr.mobileNo}
                    </Typography>
                )}
                <Button
                    variant="contained"
                    onClick={handleMobilenoEnter}
                    className={Styles.dematButton}
                >
                    {t.buttonText}
                </Button>
            </Grid2>

        </Box>


    )
}